import 'vendor-auto-grow-input'
import { initCKEditor } from '../shared'
import PublicationStatus from '../components/publication-status'

class ExampleEditorView {
  constructor($el) {
    if (!$el.length) return
    this.$root = $el
    this.$form = this.$root.find('.js-example-form')
    this.$root.find('.content-editor__title').autoGrowInput({ minWidth: 130, maxWidth: 600 })
    this.$resumeInput = this.$root.find('.js-clone-id-input')
    this.editor = null
    this._slugWasEmpty = !this.$root.find('.js-slug-input').val()

    this.initEditor()
    this.initPublicationControl()
    this.initSelect2()
    this.initModal()

    $(document).keydown(this.handleKeyDown.bind(this))
    $el.on('blur', '.js-job-title-input', this.handleTitleBlur.bind(this))
    $el.on('blur', '.js-slug-input', this.handleSlugBlur.bind(this))
    $el.on('click', '.js-example-item', this.handleExamplesClick.bind(this))
    $el.on('click', '.js-related-example-item', this.handleRelatedExamplesClick.bind(this))
    $el.on('click', '.js-reload-thumbnail', this.handleReloadThumbnail.bind(this))
    $el.on(
      'click',
      '.js-reload-seniority-thumbnail-junior',
      this.handleSeniorityReloadThumbnail.bind(this, 'junior'),
    )
    $el.on(
      'click',
      '.js-reload-seniority-thumbnail-senior',
      this.handleSeniorityReloadThumbnail.bind(this, 'senior'),
    )
    $el.on(
      'click',
      '.js-reload-seniority-thumbnail-mid',
      this.handleSeniorityReloadThumbnail.bind(this, 'mid'),
    )
    $el.on('click', '.js-create-multi-example', this.handleCreateMultiExample.bind(this))
    $el.on('click', '.js-fix-multi-example', this.handleFixMultiExample.bind(this))
    $el.on('click', '.js-clear-multi-example', this.handleClearMultiExample.bind(this))
    $el.on('click', '.js-generate-junior', this.handleGenerateSeniorityExample.bind(this, 'junior'))
    $el.on('click', '.js-generate-mid', this.handleGenerateSeniorityExample.bind(this, 'mid'))
    $el.on('click', '.js-generate-senior', this.handleGenerateSeniorityExample.bind(this, 'senior'))
    $el.on('click', '.js-delete-junior', this.handleDeleteSeniorityExample.bind(this, 'junior'))
    $el.on('click', '.js-delete-mid', this.handleDeleteSeniorityExample.bind(this, 'mid'))
    $el.on('click', '.js-delete-senior', this.handleDeleteSeniorityExample.bind(this, 'senior'))
    $el.on('click', '.js-regenerate-comments', this.handleRegenerateComments.bind(this))
    $el.on('click', '.js-generate-missing-comments', this.handleGenerateMissingComments.bind(this))
    $el.on('click', '.js-view-comments', this.handleViewCommentsClick.bind(this))
    $el.on('click', '.js-compare-content', this.handleCompareContentClick.bind(this))
  }

  // ---
  // Init
  // ---
  initSelect2() {
    const global = this
    // Set up resume input
    this.$resumeInput.each(function (_, element) {
      $(element).select2({
        templateResult: state => {
          return global.formatResumeDropdownItem(state, element)
        },
      })
    })

    // Set up related examples
    const $relatedExamples = this.$root.find('.js-clone-related')
    $relatedExamples.select2()

    // Set up original example
    const $canonicalResources = this.$root.find('.js-canonical-resources')
    $canonicalResources.select2({
      templateResult: state => {
        const takenIds = $canonicalResources.data('takenIds')
        const isResumeTaken = takenIds.indexOf(parseInt(state.id)) !== -1
        if (!state.id) {
          return state.text
        }
        const template = `
          <span class="${isResumeTaken ? 'assoc-resume-item--taken' : ''}">
            ${state.text}
          </span>
        `
        return $(template)
      },
    })
  }

  initEditor() {
    const el = this.$root.find('.content-editor__editor')
    const publications = (el.data('publications') || []).map(this.camelizeKeys)

    initCKEditor(el.get(0), {
      internalLink: { publications },
    })
      .then(newEditor => {
        this.editor = newEditor
        this.editor.editing.view.focus()
      })
      .catch(error => {
        console.error(error)
      })
  }

  initPublicationControl() {
    const $publication = this.$root.find('.js-publication')

    const publicationStatus = new PublicationStatus($publication)

    $publication.on('change', () => {
      publicationStatus.updateStatus()
    })
  }

  formatResumeDropdownItem(state, input) {
    const takenIds = $(input).data('takenIds')
    const isResumeTaken = takenIds.indexOf(parseInt(state.id)) !== -1

    if (!state.id) {
      return state.text
    }

    const template = `
      <div class="assoc-resume-item ${isResumeTaken ? 'assoc-resume-item--taken' : ''}">
        <span class="assoc-resume-item__id">#${state.id}</span>
        ${state.text}
      </div>
    `

    return $(template)
  }

  camelizeKeys(obj) {
    return Object.keys(obj).reduce((camelCasedObj, field) => {
      return {
        ...camelCasedObj,
        [_.camelCase(field)]: obj[field],
      }
    }, {})
  }

  // ---
  // Handlers
  // ---
  handleKeyDown(event) {
    if (!this.editor) return

    if ((event.ctrlKey || event.metaKey) && event.which === 83) {
      event.preventDefault()
      this.editor.updateSourceElement()
      this.$form.submit()
      return false
    }

    if ((event.ctrlKey || event.metaKey) && event.which === 80) {
      event.preventDefault()
      document.getElementById('preview-link').click()
      return false
    }
  }

  handleRelatedExamplesClick(event) {
    const $relatedExample = $(event.target)
    const id = $relatedExample.data('related-example-id')
    const $example = this.$root.find(`[data-example-id=${id}]`)
    $example.removeClass('is-current')
    $relatedExample.remove()

    // Remove related id from hidden field
    const $relatedIds = this.$root.find('.js-related-ids')[0]
    let ids = JSON.parse($relatedIds.value)
    let interim = ids.filter(i => i !== id)
    $relatedIds.value = JSON.stringify(interim)
  }

  handleExamplesClick(event) {
    const $example = $(event.target)
    const id = $example.data('example-id')
    const $relatedExample = this.$root.find(`[data-related-example-id=${id}]`)[0]

    if ($relatedExample) return // return if example is already in the list

    // Add new related example item
    const $takenExamplesBlock = this.$root.find('.js-related-block')
    const eltClass = 'example-form__related-example js-related-example-item is-current is-related'
    $takenExamplesBlock.append(`
      <div
        data-related-example-id="${id}"
        class="${eltClass}"
      >
        ${$example.text()}
      </div>`)
    $example.addClass('is-current')

    // Add example id to hidden field
    const $relatedIds = this.$root.find('.js-related-ids')[0]
    let ids = $relatedIds.value
    let interim = JSON.parse(ids)
    interim.push(id)
    $relatedIds.value = JSON.stringify(interim)
  }

  handleSlugBlur(event) {
    const $el = $(event.target)

    // mark that slug has been modified
    if ($el.val()) {
      this._touchedSlug = true
    }
  }

  handleTitleBlur(event) {
    const $field = $(event.target)
    const $slugField = this.$root.find('.js-slug-input')

    if (!this._slugWasEmpty || this._touchedSlug) return

    const url = this.$form.data('slugify-url')
    $slugField.prop('disabled', true)
    $.post({ url: url, data: { value: $field.val() } })
      .done(data => {
        $slugField.val(data.transformed)
      })
      .always(() => {
        $slugField.prop('disabled', false)
      })
  }

  handleReloadThumbnail() {
    const $button = this.$root.find('.js-reload-thumbnail')
    $button.toggleClass('is-loading', true)

    const exampleId = this.$form.data('example-id')
    const url = `/admin/examples/${exampleId}/update-thumbnail`

    $.post(url).then(() => {
      $button.toggleClass('is-loading', false)
    })
  }

  handleSeniorityReloadThumbnail(level) {
    const $button = this.$root.find(`.js-reload-seniority-thumbnail-${level}`)
    $button.toggleClass('is-loading', true)

    const exampleId = this.$form.data('example-id')
    const url = `/admin/examples/${exampleId}/update_seniority_thumbnail`

    $.post(url, { level: level }).then(() => {
      $button.toggleClass('is-loading', false)
    })
  }

  handleCreateMultiExample() {
    const $button = this.$root.find(`.js-create-multi-example`)
    $button.toggleClass('is-loading', true)

    const exampleId = this.$form.data('example-id')
    const url = `/admin/examples/${exampleId}/create_multi_examples`

    $.post(url).then(() => {
      $button.toggleClass('is-loading', false)
    })
  }

  handleFixMultiExample() {
    const $button = this.$root.find(`.js-fix-multi-example`)
    $button.toggleClass('is-loading', true)

    const exampleId = this.$form.data('example-id')
    const url = `/admin/examples/${exampleId}/fix_multi_examples`

    $.post(url).then(() => {
      $button.toggleClass('is-loading', false)
    })
  }

  handleClearMultiExample() {
    const $button = this.$root.find(`.js-clear-multi-example`)
    $button.toggleClass('is-loading', true)

    const exampleId = this.$form.data('example-id')
    const url = `/admin/examples/${exampleId}/clear_multi_examples`

    $.post(url).then(() => {
      $button.toggleClass('is-loading', false)
      window.location.reload()
    })
  }

  handleGenerateSeniorityExample(level) {
    const $button = this.$root.find(`.js-generate-${level}`)

    // Prevent multiple clicks by disabling the button
    if ($button.hasClass('is-loading')) {
      return // If already loading, don't do anything
    }

    $button.toggleClass('is-loading', true)
    $button.prop('disabled', true) // Disable the button

    const exampleId = this.$form.data('example-id')
    const url = `/admin/examples/${exampleId}/generate_seniority_example`

    $.post(url, { level: level })
      .done(response => {
        $button.toggleClass('is-loading', false)
        alert('The example will be generated in a few minutes.')
      })
      .fail(jqXHR => {
        $button.toggleClass('is-loading', false)
        const errorMessage =
          jqXHR.responseJSON && jqXHR.responseJSON.error
            ? jqXHR.responseJSON.error
            : 'An error occurred. Please try again.'
        alert(errorMessage)
      })
      .always(() => {
        $button.prop('disabled', false)
      })
  }

  handleDeleteSeniorityExample(level) {
    const $button = this.$root.find(`.js-delete-${level}`)
    $button.toggleClass('is-loading', true)

    const exampleId = this.$form.data('example-id')
    const url = `/admin/examples/${exampleId}/delete_seniority_example`

    $.post(url, { level: level }).then(() => {
      $button.toggleClass('is-loading', false)
      window.location.reload()
    })
  }

  handleRegenerateComments(event) {
    const $button = $(event.currentTarget)

    // Prevent multiple clicks
    if ($button.hasClass('is-loading')) {
      return
    }

    $button.toggleClass('is-loading', true)
    $button.prop('disabled', true)

    const exampleId = this.$form.data('example-id')
    const url = `/admin/examples/${exampleId}/regenerate_related_examples_comments`

    $.post(url)
      .done(response => {
        $button.toggleClass('is-loading', false)
        alert('Comments regeneration started. This may take a few minutes to complete.')
      })
      .fail(jqXHR => {
        $button.toggleClass('is-loading', false)
        const errorMessage =
          jqXHR.responseJSON && jqXHR.responseJSON.error
            ? jqXHR.responseJSON.error
            : 'An error occurred. Please try again.'
        alert(errorMessage)
      })
      .always(() => {
        $button.prop('disabled', false)
      })
  }

  handleGenerateMissingComments(event) {
    const $button = $(event.currentTarget)

    // Prevent multiple clicks
    if ($button.hasClass('is-loading')) {
      return
    }

    const exampleId = this.$form.data('example-id')
    const url = `/admin/examples/${exampleId}/generate_missing_comments`

    $button.toggleClass('is-loading', true)
    $button.prop('disabled', true)

    $.post(url)
      .done(response => {
        $button.toggleClass('is-loading', false)
        window.alert(response.success || response.message)
      })
      .fail(jqXHR => {
        $button.toggleClass('is-loading', false)
        const errorMessage =
          jqXHR.responseJSON && jqXHR.responseJSON.error
            ? jqXHR.responseJSON.error
            : 'An error occurred. Please try again.'
        window.alert(errorMessage)
      })
      .always(() => {
        $button.prop('disabled', false)
      })
  }

  handleViewCommentsClick(event) {
    event.preventDefault()
    $('.related-comments-modal').css('display', 'flex')
  }

  handleCompareContentClick(event) {
    event.preventDefault()
    $('.compare-content-modal').css('display', 'flex')
  }

  initModal() {
    const $modals = $('.related-comments-modal, .compare-content-modal')
    $modals.find('.modal-close, .modal-close-btn').on('click', function () {
      $(this).closest('.modal-overlay').css('display', 'none')
    })

    $modals.on('click', function (event) {
      if ($(event.target).hasClass('modal-overlay')) {
        $(this).css('display', 'none')
      }
    })

    $(document).on('keydown', event => {
      if (event.key === 'Escape') {
        $modals.filter(':visible').css('display', 'none')
      }
    })

    // Make rows selectable
    $modals.on('click', '.comment-row', event => {
      const isCtrlPressed = event.ctrlKey || event.metaKey

      if (!isCtrlPressed) {
        $('.comment-row').not(event.currentTarget).removeClass('selected')
      }

      $(event.currentTarget).toggleClass('selected')
      const $regenerateBtn = $('.modal-regenerate-selected')
      if ($('.comment-row.selected').length > 0) {
        $regenerateBtn.show()
      } else {
        $regenerateBtn.hide()
      }
    })

    $('.modal-regenerate-selected').on('click', () => {
      const selectedIds = $('.comment-row.selected')
        .map(function () {
          return $(this).data('id')
        })
        .get()

      if (selectedIds.length > 0) {
        const exampleId = this.$form.data('example-id')
        const url = `/admin/examples/${exampleId}/generate_missing_comments`

        const confirmRegeneration = window.confirm(
          `Are you sure you want to regenerate ${selectedIds.length} selected comments?`,
        )

        if (confirmRegeneration) {
          const $button = $('.modal-regenerate-selected')
          $button.prop('disabled', true).text('Regenerating...')

          $.post(url, {
            force: true,
            force_ids: selectedIds,
          })
            .done(response => {
              $button.prop('disabled', false).text('Regenerate Selected')
              window.alert(response.success || response.message)
            })
            .fail(jqXHR => {
              $button.prop('disabled', false).text('Regenerate Selected')
              const errorMessage =
                jqXHR.responseJSON && jqXHR.responseJSON.error
                  ? jqXHR.responseJSON.error
                  : 'Error regenerating comments. Please try again.'
              window.alert(errorMessage)
            })
        }
      }
    })
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new ExampleEditorView($('.example-post-view'))
})
